import { ComponentProps } from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import { PageCTALink } from '../../../components/landing/display'

export const CTAAnnotation = styled.p`
  margin: 0;
  font-weight: 200;
  line-height: 1.4;

  font-size: ${({ theme }) => theme['-ds-font-size-md']['font-size'].value};

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-xl']['font-size'].value};
  `}
`

type GetStartedCTAProps = {
  search: string
  isInvited?: boolean
} & ComponentProps<typeof PageCTALink>

export const GetStartedCTA = ({
  isInvited,
  search,
  info,
  noMarginTop,
}: GetStartedCTAProps) => {
  const href = isInvited ? `/set-password${search}` : '/my/listings/new'

  return (
    <PageCTALink href={href} info={info} noMarginTop={noMarginTop} rounded>
      Get Started
    </PageCTALink>
  )
}
